import { Component } from 'vue-property-decorator';
import BpcMediaTable from '@core/components/tables/media-table/media-table.vue';
import Vue from 'vue';

@Component({
  name: 'bpc-media',
  components: {
    'bpc-media-table': BpcMediaTable,
  },
})
export default class MediaFile extends Vue {
  /* Lifecycle hooks */
  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
